import React, { useState } from 'react';
import { Box, TextField, IconButton, Paper } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import AttachFileIcon from '@mui/icons-material/AttachFile';

interface ChatInputProps {
  onSendMessage: (message: string) => void;
  onFileUpload?: (file: File) => void;
}

const ChatInput: React.FC<ChatInputProps> = ({ onSendMessage, onFileUpload }) => {
  const [message, setMessage] = useState('');
  
  const handleSend = () => {
    if (message.trim()) {
      onSendMessage(message);
      setMessage('');
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0] && onFileUpload) {
      onFileUpload(e.target.files[0]);
    }
  };

  return (
    <Paper 
      elevation={3} 
      sx={{ 
        p: 2,
        position: 'sticky',
        bottom: 0,
        backgroundColor: 'background.paper' 
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <input
          accept=".csv,.xlsx,.xls,.json"
          id="file-upload"
          type="file"
          style={{ display: 'none' }}
          onChange={handleFileChange}
        />
        <label htmlFor="file-upload">
          <IconButton component="span" color="primary">
            <AttachFileIcon />
          </IconButton>
        </label>
        <TextField
          fullWidth
          multiline
          maxRows={4}
          placeholder="Ask something about your financial data..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyPress={handleKeyPress}
          variant="outlined"
          sx={{ mx: 1 }}
        />
        <IconButton 
          color="primary" 
          onClick={handleSend}
          disabled={!message.trim()}
          sx={{ 
            bgcolor: message.trim() ? 'primary.main' : 'grey.300',
            color: message.trim() ? 'white' : 'grey.500',
            '&:hover': {
              bgcolor: message.trim() ? 'primary.dark' : 'grey.300',
            }
          }}
        >
          <SendIcon />
        </IconButton>
      </Box>
    </Paper>
  );
};

export default ChatInput;
